import { render, staticRenderFns } from "./Xiaochengxuma.vue?vue&type=template&id=7b21bb35&"
import script from "./Xiaochengxuma.vue?vue&type=script&lang=js&"
export * from "./Xiaochengxuma.vue?vue&type=script&lang=js&"
import style0 from "./Xiaochengxuma.vue?vue&type=style&index=0&id=7b21bb35&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports